import React from "react";
import Memes from "../Memes/Memes";

const Home = () => {
  return (
    <div>
      <Memes />
    </div>
  );
};

export default Home;
